import { useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { EventBusyOutlined } from '@mui/icons-material';

export default function CancelledPage() {
  return (
    <Grid container spacing={4} paddingX={4}>
      <Grid item xs={12} display="flex" justifyContent="center" marginY={2}>
        <EventBusyOutlined />
        <Typography ml={2}>{`You've cancelled this event registration`}</Typography>
      </Grid>
    </Grid>
  );
}
